import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';

import LayoutAppHeader from '../../shared/components/Layout/components/container/LayoutAppHeader';
import LeaderboardTvHeader from './components/LeaderboardTvHeader';

const LayoutContainer = styled('div')`
  background-color: #f5f5f5;
  overflow-y: ${(props) => (props.fullWidth ? 'hidden' : 'scroll')};
`;

const MainContent = styled('main')`
  position: relative;
  height: auto;
  height: 100%;
  min-height: 100%;
  padding: ${(props) => (props.fullWidth ? '0px' : '64px 15px 15px 15px')};
  ${(props) => (props.fullWidth ? (
    'overflow: hidden;'
  ) : '')}
`;

const LeaderboardLayout = ({ children, fullWidth }) => {
  const isTvMode = useSelector((state) => state.leaderboard.ui.isTvMode);
  const currentUser = useSelector((state) => state.auth.data.currentUser);

  const { userSkin: skin = {} } = currentUser || {};
  const { darkTheme: isPrimaryDarkTheme = false, logo = null } = skin || {};

  return (
    <LayoutContainer fullWidth={fullWidth}>
      {isTvMode && (
        <LeaderboardTvHeader
          logo={logo}
          isPrimaryDarkTheme={isPrimaryDarkTheme}
        />
      )}
      <LayoutAppHeader hideHeader={isTvMode} />
      <MainContent
        className={fullWidth ? '' : 'container'}
        fullWidth={fullWidth}
      >
        {children}
      </MainContent>
    </LayoutContainer>
  );
};

LeaderboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
};

LeaderboardLayout.defaultProps = {
  fullWidth: false,
};

export default LeaderboardLayout;
